const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const normalizeEmail = (email: string): string => email.trim().toLowerCase()

const isValidEmail = (email: string): boolean => EMAIL_PATTERN.test(email)

const parseEmailsFromText = (text: string): string[] => {
  if (!text.trim()) return []

  return Array.from(
    new Set(
      text
        .split(/[\n,;\s]+/)
        .map(normalizeEmail)
        .filter(email => email.length > 0 && isValidEmail(email)),
    ),
  )
}

const parseEmailsFromCsvFile = (file: File): Promise<string[]> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const text = typeof reader.result === 'string' ? reader.result : ''
      resolve(parseEmailsFromText(text))
    }
    reader.onerror = () => reject(new Error('No se pudo leer el archivo CSV'))
    reader.readAsText(file)
  })

const mergeEmails = (...groups: string[][]): string[] =>
  Array.from(
    new Set(
      groups
        .flat()
        .map(normalizeEmail)
        .filter(isValidEmail),
    ),
  )

export { parseEmailsFromText, parseEmailsFromCsvFile, mergeEmails, isValidEmail }
